"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataTableActions
 *
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
var IconComponent_1 = __importDefault(require("../../shared/components/FormComponents/IconComponent"));
var getFetchHeaders_1 = __importDefault(require("../../shared/util/getFetchHeaders"));
var messageTypes_1 = require("../../shared/types/messageTypes");
var translateMessage_1 = __importDefault(require("../../shared/util/translateMessage"));
var crude_selector_1 = require("../../store/crude/crude.selector");
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var deleteEntityData_1 = __importDefault(require("../../fetch/deleteEntityData"));
var DialogComponent_1 = __importDefault(require("../../shared/components/MessageComponents/DialogComponent"));
var react_i18next_1 = require("react-i18next");
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var Backspace_1 = __importDefault(require("@mui/icons-material/Backspace"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var styles_1 = require("@mui/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    mobile: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
    },
    desktop: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'nowrap',
    },
}); });
var DataTableActions = function (props) {
    var _a, _b;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var _c = react_1.useState(), deleteResponse = _c[0], setDeleteResponse = _c[1];
    var _d = react_1.useState(false), openDeleteDialog = _d[0], setOpenDeleteDialog = _d[1];
    react_1.useEffect(function () {
        if (deleteResponse) {
            props.onDeleteEntity && props.onDeleteEntity();
            if (deleteResponse.message && crudeLabels) {
                var text = translateMessage_1.default(deleteResponse.message, crudeLabels, props.entity, props.id);
                var newMessage = {
                    eventType: messageTypes_1.EventType.delete,
                    severity: deleteResponse.status && deleteResponse.status < 400 ? messageTypes_1.Severity.success : messageTypes_1.Severity.error,
                    message: text,
                };
                deleteResponse && dispatch(crudeActions.addMessage(newMessage));
            }
        }
    }, [deleteResponse]);
    var editEntity = function () {
        props.onClickEntity && props.onClickEntity(props.id);
    };
    var deleteEntity = function () {
        setOpenDeleteDialog(false);
        deleteEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, props.entity, fetchHeaders, props.id, setDeleteResponse);
    };
    var getDeleteIcon = function () {
        var _a, _b, _c, _d, _e;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.deleteIcon) === 'delete' &&
                react_1.default.createElement(Delete_1.default, null),
            ((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.deleteIcon) === 'deleteForever' &&
                react_1.default.createElement(DeleteForever_1.default, null),
            ((_c = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _c === void 0 ? void 0 : _c.deleteIcon) === 'backspace' &&
                react_1.default.createElement(Backspace_1.default, null),
            ((_d = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _d === void 0 ? void 0 : _d.deleteIcon) === 'clear' &&
                react_1.default.createElement(Clear_1.default, null),
            ((_e = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _e === void 0 ? void 0 : _e.deleteIcon) === 'highlightOff' &&
                react_1.default.createElement(HighlightOff_1.default, null)));
    };
    var instanceUpdateAllowed = props.instancePermissions && props.instancePermissions[props.id].entity.updateAllowed;
    var instanceDeleteAllowed = props.instancePermissions && props.instancePermissions[props.id].entity.deleteAllowed;
    var updateAllowed = typeof instanceUpdateAllowed === 'boolean' ? instanceUpdateAllowed : (_a = props.entitySchema) === null || _a === void 0 ? void 0 : _a.entityPermissions.updateAllowedByDefault;
    var deleteAllowed = typeof instanceDeleteAllowed === 'boolean' ? instanceDeleteAllowed : (_b = props.entitySchema) === null || _b === void 0 ? void 0 : _b.entityPermissions.deleteAllowedByDefault;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: screenDesign === commonTypes_1.ScreenDesign.mobile ? classes.mobile : classes.desktop },
            react_1.default.createElement(react_1.default.Fragment, null,
                updateAllowed
                    ? react_1.default.createElement(IconComponent_1.default, { icon: react_1.default.createElement(Edit_1.default, null), onClick: function () { return editEntity(); } })
                    : react_1.default.createElement(IconComponent_1.default, { icon: react_1.default.createElement(Visibility_1.default, null), onClick: function () { return editEntity(); } }),
                deleteAllowed &&
                    react_1.default.createElement(IconComponent_1.default, { icon: getDeleteIcon(), onClick: function () { return setOpenDeleteDialog(true); } }))),
        react_1.default.createElement(DialogComponent_1.default, { message: t('crude:deleteEntityQuestion'), title: t('crude:deleteEntityQuestionTitle'), open: openDeleteDialog, request: true, severity: messageTypes_1.Severity.warning, onClose: function () { return setOpenDeleteDialog(false); }, confirmLabel: t('crude:delete'), autoClose: false, onConfirm: deleteEntity, onCancel: function () { return setOpenDeleteDialog(false); } })));
};
exports.default = DataTableActions;
